export default __webpack_public_path__ + "static/media/slot_game_banner.d0742946.png";